import React, { useState } from 'react';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { AppState } from 'src/store';
import { DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { useTab } from 'src/components/hooks/useTab';
import { useDispatch, useSelector } from 'react-redux';
import { setSqReportPopupValue, setSqReportStatus } from 'src/store/sqReport';

function SQPopup() {
  const dispatch = useDispatch();

  const { tabVal } = useTab();
  const confirmexitvalue: any = useSelector((state: AppState) => state.confirmexitvalue.confirmexitvalue);

  const confirmexitpopupval: any = useSelector((state: AppState) => state.confirmexitpopupval);

  const [confirmPopupEnable, setConfirmPopupEnable] = useState<boolean>(false);

  const handleYes = () => {
    setConfirmPopupEnable(false);
  };

  const handleNo = () => {
    setConfirmPopupEnable(false);
    dispatch(setSqReportStatus('1'));
    setConfirmExitValue(dispatch, false);
    dispatch(setSqReportPopupValue(false));
  };

  React.useEffect(() => {
    if (confirmexitpopupval.confirmexitpopupval == true && confirmexitvalue == true) {
      setConfirmPopupEnable(true);
      localStorage.setItem('popupShowed', 'true');
    } else {
      setConfirmPopupEnable(false);
      localStorage.setItem('popupShowed', 'false');
    }
  }, [confirmexitpopupval, tabVal]);

  return (
    <PopupComponent
      open={confirmPopupEnable}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{'Confirm'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure, you want to submit the report for review ?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleYes()}>Yes</Button>
        <Button onClick={() => handleNo()}>No</Button>
      </DialogActions>
    </PopupComponent>
  );
}

export default SQPopup;
